import type {
  AlgoliaJobAdsRequestParameters,
  FacetsWithValues,
} from "@/modules/jobAds/client/utils/getAlgoliaFacetFiltersFromParams"

import _cloneDeep from "lodash/cloneDeep"
import { NIL as NIL_UUID } from "uuid"

import { ALGOLIA_FACETS } from "@/modules/jobAds/client/constants"
import { computeAvailableSearchConfigOptions } from "@/modules/jobAds/client/utils/computeAvailableSearchConfigOptions"
import { logger } from "@/modules/monitoring/logger"

export const getAlgoliaFacetFiltersFromBusinessRules = (
  initialFacetFilters: FacetsWithValues,
  initialParams: AlgoliaJobAdsRequestParameters
): FacetsWithValues => {
  const { contractTypesSearchConfig, studyLevelsSearchConfig } = initialParams
  const result: FacetsWithValues = _cloneDeep(initialFacetFilters)

  const availableContractTypeValues = contractTypesSearchConfig
    ? computeAvailableSearchConfigOptions(contractTypesSearchConfig)
    : []
  const availableStudyLevelValues = studyLevelsSearchConfig
    ? computeAvailableSearchConfigOptions(studyLevelsSearchConfig)
    : []

  // If no selected contract types from user, we need to add all contract types from current CC
  if (initialFacetFilters.CONTRACT_TYPE.length === 0) {
    const filteredAvailableContractTypeValues = availableContractTypeValues.filter(Boolean)

    if (availableContractTypeValues.length !== filteredAvailableContractTypeValues.length) {
      logger.info(
        `Some contract types were removed because they were empty or invalid: ${JSON.stringify(
          availableContractTypeValues
        )}`
      )
    }

    result.CONTRACT_TYPE = filteredAvailableContractTypeValues.map(
      value => `${ALGOLIA_FACETS.CONTRACT_TYPE}:'${value}'`
    )
  }
  // If no selected study levels from user, we need to add all study levels from current CC
  if (initialFacetFilters.STUDY_LEVELS.length === 0) {
    const filteredAvailableStudyLevelValues = availableStudyLevelValues.filter(Boolean)

    if (availableStudyLevelValues.length !== filteredAvailableStudyLevelValues.length) {
      logger.info(
        `Some study levels were removed because they were empty or invalid: ${JSON.stringify(
          availableStudyLevelValues
        )}`
      )
    }

    result.STUDY_LEVELS = filteredAvailableStudyLevelValues.map(value => `${ALGOLIA_FACETS.STUDY_LEVELS}:'${value}'`)
  }
  // We always want to see job ad that are not curriculum related
  result.CURRICULUM_IDS.push(`${ALGOLIA_FACETS.CURRICULUM_IDS}:'${NIL_UUID}'`)

  // We always want to be able to see public (www) job ads
  result.SCHOOL_IDS.push(`${ALGOLIA_FACETS.SCHOOL_IDS}:'${NIL_UUID}'`)

  return result
}
